import { createPluginSpec } from '#src/plugins/spec/types.js';
export function createAdminCrudInputWebConfig(config) {
    return config;
}
export function createAdminCrudInputWebImplementation() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const inputs = new Map();
    return {
        registerInputWebConfig(input) {
            if (inputs.has(input.name)) {
                throw new Error(`Admin CRUD input with name ${input.name} is already registered`);
            }
            inputs.set(input.name, input);
        },
        getInputWebConfig(name, builtInInputs = []) {
            const builtInInput = builtInInputs.find((b) => b.name === name);
            if (builtInInput) {
                return builtInInput;
            }
            const input = inputs.get(name);
            if (!input) {
                throw new Error(`Unable to find input with name ${name}`);
            }
            return input;
        },
        getInputWebConfigs(builtInInputs = []) {
            return [...builtInInputs, ...inputs.values()];
        },
    };
}
/**
 * Spec for adding config component for plugin
 */
export const adminCrudInputWebSpec = createPluginSpec('core/admin-crud-input-web', { defaultInitializer: createAdminCrudInputWebImplementation });
//# sourceMappingURL=admin-crud-input-web-spec.js.map